/**
 * Gallery · Strips · Classic. Anyone can switch (it's remembered in their browser); an admin also
 * sees what everyone gets by default and can make the current look that default.
 */
import React, { useState } from "react";
import { LIBRARY_LOOKS, LibraryLook, useLibraryLook } from "./libraryLook";
import { LOOK_NAMES, LOOK_TEXT } from "./libraryLookText";

const DARK = {
  seg: { display: "inline-flex", gap: 2, background: "#1a1a1a", border: "1px solid #333", borderRadius: 10, padding: 3 } as React.CSSProperties,
  btn: (on: boolean): React.CSSProperties => ({
    border: 0, cursor: "pointer", borderRadius: 6, padding: "5px 12px", fontFamily: "Outfit, sans-serif", fontSize: 13,
    fontWeight: 600, whiteSpace: "nowrap", color: on ? "#fff" : "#ddd", background: on ? "#e53935" : "transparent",
  }),
};

const LookSwitch: React.FC<{ dark?: boolean }> = ({ dark = false }) => {
  const { look, siteLook, canEdit, setLook, makeDefault } = useLibraryLook();
  const [note, setNote] = useState("");

  const saveDefault = async () => {
    const name = LOOK_NAMES[look].name;
    if (!window.confirm(LOOK_TEXT.confirmDefault(name))) return;
    try {
      await makeDefault(look);
      setNote(LOOK_TEXT.savedDefault(name));
    } catch (e) {
      setNote((e as Error).message);
    }
  };

  const button = (key: LibraryLook) => (
    <button
      type="button"
      key={key}
      title={LOOK_NAMES[key].title}
      className={!dark && look === key ? "on" : ""}
      style={dark ? DARK.btn(look === key) : undefined}
      onClick={() => { setNote(""); setLook(key); }}
    >
      {LOOK_NAMES[key].icon} {LOOK_NAMES[key].name}
    </button>
  );

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
      {dark && <span style={{ fontFamily: "Outfit, sans-serif", fontSize: 13, color: "#bbb" }}>{LOOK_TEXT.label}:</span>}
      <div className={dark ? undefined : "seg"} style={dark ? DARK.seg : undefined} aria-label={LOOK_TEXT.label}>
        {LIBRARY_LOOKS.map(button)}
      </div>
      {canEdit && (
        <div className="admin" style={dark ? { fontFamily: "Outfit, sans-serif", fontSize: 12, color: "#888", display: "flex", gap: 8 } : undefined}>
          {note || LOOK_TEXT.everyoneSees(LOOK_NAMES[siteLook].name)}
          {look !== siteLook && !note && (
            <button type="button" onClick={saveDefault} style={dark ? { border: 0, background: "none", color: "#ff5c7a", fontWeight: 700, cursor: "pointer", padding: 0, fontSize: 12 } : undefined}>
              {LOOK_TEXT.makeDefault}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default LookSwitch;
